import moment from 'moment';
export const ROLE_AUTHORIZATION_TYPE_SLIDE = 'AUTHORIZATION_TYPE_SLIDE';
export const hasSlideRole = (profile, now) => {
    const { authorizations } = profile || {};
    return !!(authorizations || []).find((role) => role.authorizationType === ROLE_AUTHORIZATION_TYPE_SLIDE &&
        moment(role.authorizationExpire).isAfter(now));
};
